module.exports = __webpack_public_path__ + "static/media/smoke.ed1872ef.mp4";